import { useRef } from 'react';

/**
 * @category Hooks
 * @param {Function} init - Callback that serves as an initializer
 *
 * This hook is used to create a one off instance of a value that will persist renders
 * useRef does have the same behaviour but for example if you are creating a instance
 * of a class on the useRef, like useRef(new Class()), this class will be called
 * on every render even tho you only need the first instance of it.
 * So this hook takes on a function that only runs once to get that instance:
 * useLazyRef(() => new Class()) - Will only call this class once during the component
 * render lifeycle
 */
export default function useLazyRef(init) {
  const ref = useRef();
  // This is safe to do outside of a effect here, because this will only
  // ever run once. This is concurrent mode safe.

  if (ref.current === undefined) {
    ref.current = init();
  }
  return ref;
}